import { z } from "zod";
import { ENTITLEMENT_STATUSES } from "../pricing.js";

/** Console di piattaforma (solo superadmin di Kipo). */

export const platformTenantListSchema = z.object({
  q: z.string().trim().max(120).optional(),
  status: z.enum(["all", ...ENTITLEMENT_STATUSES]).default("all"),
  page: z.number().int().min(1).default(1),
  pageSize: z.number().int().min(1).max(100).default(25),
});
export type PlatformTenantListInput = z.infer<typeof platformTenantListSchema>;

export const platformEntitlementUpdateSchema = z.object({
  tenantId: z.string().uuid(),
  status: z.enum(ENTITLEMENT_STATUSES).optional(),
  /** giorni di prova da aggiungere a partire da oggi (o dalla scadenza attuale, se futura) */
  extendTrialDays: z.number().int().min(1).max(365).optional(),
  sdiEnabled: z.boolean().optional(),
  note: z.string().trim().max(500).optional(),
});
export type PlatformEntitlementUpdateInput = z.infer<typeof platformEntitlementUpdateSchema>;

export const platformUserListSchema = z.object({
  q: z.string().trim().max(120).optional(),
  page: z.number().int().min(1).default(1),
  pageSize: z.number().int().min(1).max(100).default(25),
});

export const platformUserUpdateSchema = z.object({
  userId: z.string().uuid(),
  disabled: z.boolean().optional(),
  superadmin: z.boolean().optional(),
});

export const impersonateSchema = z.object({
  tenantId: z.string().uuid(),
  /** se assente si entra come proprietario dello spazio di lavoro */
  userId: z.string().uuid().optional(),
  reason: z.string().trim().min(3).max(300),
});
export type ImpersonateInput = z.infer<typeof impersonateSchema>;

export const PLATFORM_PAYMENT_SOURCES = ["stripe"] as const;
export type PlatformPaymentSource = (typeof PLATFORM_PAYMENT_SOURCES)[number];

export const platformPaymentListSchema = z.object({
  q: z.string().trim().max(120).optional(),
  mode: z.enum(["all", "live", "test"]).default("all"),
  invoiced: z.enum(["all", "yes", "no"]).default("all"),
  page: z.number().int().min(1).default(1),
  pageSize: z.number().int().min(1).max(100).default(25),
});
export type PlatformPaymentListInput = z.infer<typeof platformPaymentListSchema>;

export const platformInvoicingTokenSchema = z.object({ token: z.string().trim().min(10).max(500) });

export const platformInvoicingSettingsSchema = z.object({
  companyId: z.number().int().positive(),
  vatTypeId: z.number().int().min(0),
  foreignVatTypeId: z.number().int().min(0).nullable().default(null),
  paymentAccountId: z.number().int().positive().nullable().default(null),
  numeration: z.string().trim().max(20).default(""),
  eInvoice: z.boolean().default(true),
  eiPaymentMethod: z.string().trim().regex(/^MP\d{2}$/).default("MP08"),
  autoCreate: z.boolean().default(false),
  autoSend: z.boolean().default(false),
});
export type PlatformInvoicingSettingsInput = z.infer<typeof platformInvoicingSettingsSchema>;

export const platformInvoiceCreateSchema = z.object({
  source: z.enum(PLATFORM_PAYMENT_SOURCES),
  paymentId: z.string().uuid(),
  send: z.boolean().default(false),
});
